import { useEffect, useState } from "react";
import { StartAndEndDateField } from "V2.0/HomePages/Downloads/components/StartAndEndDateField";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { formatTime } from "V2.0/utils";
import { Button } from "V2.0/common/button";
import ConversationBySource from "./ConversationBySource";
import CallDurationStats from "./CallDurationStats";
import OutboundStatus from "./OutboundStatus";
import useConversationStats from "./Models/useConversationStats";

dayjs.extend(utc);

export default function ConversationStats(props) {
  const { workspaceId, assistantId } = props;

  const { conversationStats, fetchConversationStats } = useConversationStats(
    workspaceId,
    assistantId
  );
  const [dateRange, setDateRange] = useState({
    startDate: dayjs().startOf("day").format("x"),
    endDate: dayjs().endOf("day").format("x"),
  });

  useEffect(
    function () {
      if (workspaceId && assistantId) {
        fetchConversationStats({
          startTime: dateRange.startDate,
          endTime: dateRange.endDate,
        });
      }
    },
    [workspaceId, assistantId, dateRange]
  );

  return (
    <div className="grid grid-cols-4 gap-y-4">
      <div className="flex flex-col col-span-4">
        <div className="flex items-center gap-x-2">
          <p className="text-base font-semibold">Call Statistics</p>
          <Button
            onClick={() =>
              setDateRange((prevDateRange) => {
                return {
                  ...prevDateRange,
                  endDate: dayjs().endOf("day").format("x"),
                };
              })
            }
            plain
          >
            <ArrowPathIcon />
          </Button>
        </div>
        <div>
          <p className="text-xs">
            Last Updated at: {formatTime(conversationStats?.lastUpdatedAt)}
          </p>
        </div>
      </div>
      <div className="col-span-2">
        <StartAndEndDateField
          size="large"
          date={[dateRange.startDate, dateRange.endDate]}
          setDate={setDateRange}
          error={{ isError: false }}
          showTime={true}
          allowClear={false}
          hideLabel={true}
          format="YYYY-MM-DD HH:mm"
          autoEndOfDay={false}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 col-span-4 gap-x-4 gap-y-4">
        <div className="flex flex-col col-span-1 justify-start gap-y-4">
          <ConversationBySource
            conversationCountBySource={
              conversationStats.conversationCountBySource
            }
            isLoading={conversationStats.isLoading}
          />
          <CallDurationStats
            callDurationStats={conversationStats.callDurationStats}
            isLoading={conversationStats.isLoading}
          />
        </div>
        <div className="border rounded-lg p-4 h-full col-span-2">
          <OutboundStatus
            outboundByStatus={conversationStats.outboundCountByCampaignStatus}
            isLoading={conversationStats.isLoading}
          />
        </div>
      </div>
    </div>
  );
}
